import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=1023ad7b&scoped=true&"
import script from "./ActivityList.vue?vue&type=script&lang=ts&"
export * from "./ActivityList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=1023ad7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023ad7b",
  null
  
)

component.options.__file = "ActivityList.vue"
export default component.exports